import { c as _c } from "react/compiler-runtime";
import React from "react";
import { SanityImage } from "sanity-image";
import type { SanityAsset, SanityImageObject } from "@sanity/image-url";
import { getClient } from "../../lib/sanity.client";
export const ResponsiveImage: React.FC<{
  image: SanityImageObject;
  alt?: string;
  onClick?: () => void;
  priority?: boolean;
  sizes?: string;
  layout?: "fill" | "responsive" | "cover" | "contain";
}> = t0 => {
  const $ = _c(44);
  const {
    image,
    alt,
    onClick,
    priority,
    sizes,
    layout: t1
  } = t0;
  const layout = t1 === undefined ? "fill" : t1;
  if (!image) {
    return null;
  }
  if (!image.asset) {
    return null;
  }
  const imageId = image.asset?._ref || (image.asset as SanityAsset)._id;
  if (!imageId) {
    return null;
  }
  let projectId;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    const sanityClient = getClient();
    projectId = sanityClient.config().projectId;
    t2 = sanityClient.config();
    $[0] = projectId;
    $[1] = t2;
  } else {
    projectId = $[0];
    t2 = $[1];
  }
  const dataset = t2.dataset;
  const preview = (image as any).asset?.metadata?.lqip;
  const dimensions = (image as any).asset?.metadata?.dimensions;
  const aspectRatio = dimensions ? dimensions.width / dimensions.height : undefined;
  const mode = layout === "cover" ? "cover" : "contain";
  const t3 = layout === "fill" || layout === "cover" ? "100%" : "auto";
  let t4;
  if ($[2] !== mode || $[3] !== t3) {
    t4 = {
      objectFit: mode,
      width: "100%",
      height: t3
    };
    $[2] = mode;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const imageStyle = t4;
  let dimensionProps;
  if ($[5] !== layout) {
    dimensionProps = {};
    if (layout !== "fill" && layout !== "responsive") {
      dimensionProps.width = 800;
    }
    $[5] = layout;
    $[6] = dimensionProps;
  } else {
    dimensionProps = $[6];
  }
  if (layout === "responsive" && aspectRatio) {
    const t5 = `${aspectRatio}`;
    let t6;
    if ($[7] !== t5) {
      t6 = {
        width: "100%",
        aspectRatio: t5,
        display: "block"
      };
      $[7] = t5;
      $[8] = t6;
    } else {
      t6 = $[8];
    }
    const containerStyle = t6;
    let t7;
    if ($[9] !== imageStyle) {
      t7 = {
        ...imageStyle,
        height: "100%",
        display: "block"
      };
      $[9] = imageStyle;
      $[10] = t7;
    } else {
      t7 = $[10];
    }
    const responsiveImageStyle = t7;
    const t8 = alt || "Image";
    let t9;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = {
        dpr: typeof window !== "undefined" ? window.devicePixelRatio : 2,
        q: 80
      };
      $[11] = t9;
    } else {
      t9 = $[11];
    }
    const t10 = priority ? "eager" : "lazy";
    const t11 = sizes ?? "(min-width: 1521px) 760px, (min-width: 1181px) 640px, 90vw";
    let t12;
    if ($[12] !== dataset || $[13] !== dimensionProps || $[14] !== image.crop || $[15] !== image.hotspot || $[16] !== imageId || $[17] !== mode || $[18] !== onClick || $[19] !== preview || $[20] !== projectId || $[21] !== responsiveImageStyle || $[22] !== t10 || $[23] !== t11 || $[24] !== t8) {
      t12 = <SanityImage id={imageId} projectId={projectId} dataset={dataset} mode={mode} preview={preview} hotspot={image.hotspot} crop={image.crop} alt={t8} onClick={onClick} queryParams={t9 as any} loading={t10} sizes={t11} style={responsiveImageStyle} {...dimensionProps} />;
      $[12] = dataset;
      $[13] = dimensionProps;
      $[14] = image.crop;
      $[15] = image.hotspot;
      $[16] = imageId;
      $[17] = mode;
      $[18] = onClick;
      $[19] = preview;
      $[20] = projectId;
      $[21] = responsiveImageStyle;
      $[22] = t10;
      $[23] = t11;
      $[24] = t8;
      $[25] = t12;
    } else {
      t12 = $[25];
    }
    let t13;
    if ($[26] !== containerStyle || $[27] !== t12) {
      t13 = <div style={containerStyle}>{t12}</div>;
      $[26] = containerStyle;
      $[27] = t12;
      $[28] = t13;
    } else {
      t13 = $[28];
    }
    return t13;
  }
  const t5 = alt || "Image";
  let t6;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      dpr: typeof window !== "undefined" ? window.devicePixelRatio : 2,
      q: 80
    };
    $[29] = t6;
  } else {
    t6 = $[29];
  }
  const t7 = priority ? "eager" : "lazy";
  const t8 = sizes ?? "(min-width: 1521px) 760px, (min-width: 1181px) 640px, 90vw";
  let t9;
  if ($[30] !== dataset || $[31] !== dimensionProps || $[32] !== image.crop || $[33] !== image.hotspot || $[34] !== imageId || $[35] !== imageStyle || $[36] !== mode || $[37] !== onClick || $[38] !== preview || $[39] !== projectId || $[40] !== t5 || $[41] !== t7 || $[42] !== t8) {
    t9 = <SanityImage id={imageId} projectId={projectId} dataset={dataset} mode={mode} preview={preview} hotspot={image.hotspot} crop={image.crop} alt={t5} onClick={onClick} queryParams={t6 as any} loading={t7} sizes={t8} style={imageStyle} {...dimensionProps} />;
    $[30] = dataset;
    $[31] = dimensionProps;
    $[32] = image.crop;
    $[33] = image.hotspot;
    $[34] = imageId;
    $[35] = imageStyle;
    $[36] = mode;
    $[37] = onClick;
    $[38] = preview;
    $[39] = projectId;
    $[40] = t5;
    $[41] = t7;
    $[42] = t8;
    $[43] = t9;
  } else {
    t9 = $[43];
  }
  return t9;
};
export default ResponsiveImage;